let ServiceActionPrioritiesService = function ($http, $q) {
    const apiUrl = '/api/service-action-priorities';

    let all = (query = '', offset = 0, limit = 10) => {
        return $http.get(`${apiUrl}`, {
            params: { query, offset, limit }
        })
            .then(res => res.data)
            .catch(err => $q.reject(err));
    };

    let create = (data) => {
        return $http.post(apiUrl, data)
            .then(res => res.data)
            .catch(err => $q.reject(err));
    };

    let update = (id, data) => {
        return $http.put(`${apiUrl}/${id}`, data)
            .then(res => res.data)
            .catch(err => $q.reject(err));
    };

    let remove = (id) => {
        return $http.delete(`${apiUrl}/${id}`)
            .then(res => res.data)
            .catch(err => $q.reject(err));
    };

    return {
        all,
        create,
        update,
        remove
    };
};

ServiceActionPrioritiesService.$inject = ['$http', '$q'];

export default ServiceActionPrioritiesService;



// WEBPACK FOOTER //
// ./client/app/services/service-action-priorities.service.js